import { tn } from '../../shared/i18n';
import { burntTotal, summonOf } from '../../sim/full/summons';
import type { SimState } from '../../sim/state';
import { findAll, icon } from '../dom';
import { formatNumber } from '../format';
import type { HudPart, HudParts } from '../hud-parts';
import './summons.css';

const CALLED_MASK =
  '<path d="M3 6.5Q12 1 21 6.5Q22 16 12 22Q2 16 3 6.5z" fill="currentColor"/>' +
  '<path d="M6.5 10.5l3.5 1.4M17.5 10.5l-3.5 1.4" stroke="var(--sol)" stroke-width="2" stroke-linecap="round"/>';

export const STICK_ICON =
  '<path d="M3.5 19.5 20 5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/>' +
  '<path d="M12 12.3 11 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
  '<circle cx="20" cy="5" r="1.6" fill="currentColor"/>';

export const SPORES_ICON =
  '<circle cx="12" cy="12" r="5" fill="currentColor"/>' +
  '<g fill="currentColor"><circle cx="12" cy="3" r="1.5"/><circle cx="20" cy="9" r="1.5"/>' +
  '<circle cx="18" cy="19" r="1.5"/><circle cx="6" cy="19" r="1.5"/><circle cx="4" cy="9" r="1.5"/></g>';

export function createSummonsHud({ ribbon }: HudParts): HudPart {
  let shown = -1;
  let drops = 0;
  return {
    update(state: SimState): void {
      const summon = summonOf(state);
      const called = burntTotal(summon);
      // The drop under way keeps the bosses it was given as it began.
      const current =
        state.set.segment === 'drop'
          ? (summon?.called.length ?? 0) + (state.bossesDue ?? 0)
          : called;
      const slots = findAll(ribbon, '.ui-slot--drop', HTMLElement);
      const key =
        called * 1_000_000 +
        current * 1000 +
        slots.filter((slot) => slot.dataset.state === 'done').length;
      if (key === shown && slots.length === drops) {
        return;
      }
      shown = key;
      drops = slots.length;
      for (const slot of slots) {
        slot.querySelector('.ui-called')?.remove();
        const count = slot.dataset.state === 'current' ? current : called;
        if (count === 0 || slot.dataset.state === 'done') {
          continue;
        }
        const masks = document.createElement('span');
        masks.className = 'ui-called';
        masks.title = tn(count, '{count} boss en plus', '{count} boss en plus', {
          count: formatNumber(count),
        });
        for (let mask = 0; mask < count; mask++) {
          masks.append(icon('ui-called__mask', CALLED_MASK));
        }
        slot.append(masks);
      }
    },
  };
}
